import { HOVERING_BEHAVIOUR } from '../constants/pro-gallery-options';

export const isHoveringBehaviourNeverShow = (options) => options.hoveringBehaviour === HOVERING_BEHAVIOUR.NEVER_SHOW;
